export default "/images/56b4117c67a2745b1fb75ab080290145.avif";